import React from 'react'
import { DragObjectWithType } from 'react-dnd'
import AppLayout from '../../../../app-layout'
import { Player, Grid } from '../../models'
import DragLayer from '../drag-layer'
import PlayerListBar from '../player-list-bar'
import TileGrid from '../tile-grid'
import styles from './GameView.module.css'

export interface GameViewProps<T> {
    players: Player[]
    grid: Grid
    isMyTurn?: boolean
    controls?: React.ReactElement
    onPlace?: (x: { row: number, col: number, tile: T }) => any
}

export default function GameView<T extends DragObjectWithType>(props: GameViewProps<T>) {
    return (
        <>
            <DragLayer />
            <AppLayout
                topBar={<PlayerListBar players={props.players} />}
                bottomBar={props.controls}
                contentClassName={styles.wrapper}
            >
                <div className={styles.root}>
                    <div className={styles.grid}>
                        <div className={styles.gridInner}>
                            <TileGrid<T>
                                grid={props.grid}
                                margin={1}
                                isMyTurn={!!props.isMyTurn}
                                onPlace={props.onPlace}
                            />
                        </div>
                    </div>
                </div>
            </AppLayout>
        </>
    )
}